import React from 'react';

export default function TourWelcomeModal({ show, onStartTour, onSkipTour }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center z-50 p-4">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg max-w-sm w-full text-center space-y-4">
        {/* Simple Title */}
        <h2 className="text-xl font-bold text-gray-900">
          Take a Tour?
        </h2>

        {/* Action Buttons */}
        <div className="flex flex-col space-y-3">
          <button
            onClick={onStartTour}
            className="w-full py-3 bg-[#008f5a] text-white font-semibold rounded-lg hover:bg-[#007a4d] transition"
          >
            Start Tour
          </button>
          <button
            onClick={onSkipTour}
            className="w-full py-2 text-gray-600 font-medium hover:text-gray-800 transition"
          >
            Skip Tour
          </button>
        </div>
      </div>
    </div>
  );
} 